import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { variables } from './Variables.js';
import { FALSE } from 'sass';




export default function FootBall_MostViewed() {

  const jsonUrl = variables.basename_url + 'updates/index/Athlethixnet_HomeEn_Football.json';


  const [isLoading, setNisLoading] = useState(false);
  const navigate = useNavigate();
  const usenavigate = useNavigate();



  async function refda() {


    Get_Data_FMostViewed();
  };




  const [FootBall_MostViewed, setFootBall_MostViewed] = React.useState([]);


  async function Get_Data_FMostViewed() {

    FootBall_MostViewed.splice(0);  //to clear All data in your page


    setNisLoading(true);

    axios.get(jsonUrl)

      .then(function (response) {

        setNisLoading(false);

        console.log(response.data);

        for (let i = 0; i <= 4 && i < response.data.length; i++) {

          FootBall_MostViewed.push({

            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date.split(" ")[0],
            Image: response.data[i].Image,
            link: response.data[i].link,
            Category: response.data[i].Category,
            // Description: response.data[i].Description,
            //Aya Added these replaces:
            Description: response.data[i].Description
              .replace(/<iframe.*?<\/iframe>/gi, "")
              .replace("MENAFN", variables.domain)
              .replace(/<p.*?<\/p>/gi, "")
              .replace(/<br.*?<\/br>/gi, "")
              .replace(/<strong.*?<\/strong>/gi, ""),
          })
        }
      })
  }

  useEffect(() => {


    setNisLoading(true);

    refda();
  }, [])

  return (
    <>
      <div className="most-view-box mt-2">
        <div className="section-title">
          <a href="/Football">
            <h3 className="title">Football</h3>
          </a>
        </div>
        <div className="trending-sidebar-slider slick-initialized slick-slider">
          <div className="slick-list draggable">
            <div className="slick-track">
              <div className="post_gallery_items slick-slide slick-current slick-active" data-slick-index={0} aria-hidden="false" tabIndex={0}>
                {FootBall_MostViewed.map(da =>
                  <div key={da.news_title}>
                    <div className="post-gallery-style-2 most-view-style-2">
                      <div className="post-gallery-thumb">
                        <Link to={da.link.replace(variables.domain_name, "")}
                        >
                          <img
                            className='rounded'
                            style={{ maxWidth: '85px', minWidth: '85px', maxHeight: '57px', minHeight: '57px' }}
                            src={da.Image}
                            alt="gallery"
                          />
                        </Link>
                      </div>
                      <div className="post-gallery-content pl-4">
                        <h5 className="title">
                          <Link to={da.link.replace(variables.domain_name, "")}
                            tabIndex={-1}>
                            {da.news_title}
                          </Link>
                        </h5>
                        <div className="meta-post-2-style">
                          <div className="meta-post-categores">
                            <Link to={da.link.replace(variables.domain_name, "")}
                            >
                              {da.Category}
                            </Link>
                          </div>
                          <div className="meta-post-date">
                            <span>{da.news_date}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div></div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}